import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useMutation, ClientContext, GraphQLClient } from "graphql-hooks";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
//// Static Pages
import Footer from "./components/Footer";
import Header from "./components/Header";
import AboutPage from "./staticPages/AboutPage.js";
import TermsPage from "./staticPages/TermsPage.js";
import DifferentiationPage from "./staticPages/DifferentiationPage.js";
import DamTrainingCorporatePage from "./staticPages/DamTrainingCorporatePage.js";
import DamTrainingAcademicPage from "./staticPages/DamTrainingAcademicPage.js";
import DamTrainingRegistrationPage from "./staticPages/DamTrainingRegistrationPage.js";
import ImmrsExpPage from "./staticPages/ImmrsExpPagePage.js";
import ServicesPage from "./staticPages/ServicesPage.js";
import ProductAgnosticPage from "./staticPages/productAgnostic/ProductAgnosticPage.js";
import PracticePage from "./staticPages/practice/PracticePage.js";
import DamJourneyPage from "./staticPages/damJourney/DamJourneyPage.js";
import PrivacyPolicy from "./staticPages/PrivacyPolicy.js";
import CookiePolicyPage from "./staticPages/CookiePolicyPage.js";
import DiscoveryPage from "./staticPages/discovery/DiscoveryPage.js";
import CaseStudy from "./staticPages/CaseStudy.js";
import CaseStudyDamRepository from "./staticPages/CaseStudyDamRepository.js";
import ContactPage from "./staticPages/ContactPage.js";
import CongratsPage from "./staticPages/CongratsPage.js";

import ProspectDamQuestions from "./components/ProspectDamQuestions/ProspectDamQuestions";

////
import LandPage from "./LandPage.js";
import HomePage from "./HomePage.js";
import HomePageIndustries from "./HomePageIndustries";

// Create MUI theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#E53935",
    },
    secondary: {
      main: "#4CAF50",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 950, //600
      md: 1270, //900 1400
      lg: 1400, //1600,
      xl: 1536, //1900,
      customBreakpoint: 735,
    },
  },
});

function MainLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            {/* Routes WITHOUT header/footer */}
            <Route path="/prospect-dam-questions" element={<ProspectDamQuestions />} />

            {/* Routes WITH header/footer */}
            <Route element={<MainLayout />}>
              <Route path="/about" element={<AboutPage />} />
              <Route path="/" element={<HomePageIndustries />} />
              <Route path="/differentiation" element={<DifferentiationPage />} />
              <Route
                path="/dam-trainiong-corporate"
                element={<DamTrainingCorporatePage />}
              />
              <Route
                path="/dam-trainiong-academic"
                element={<DamTrainingAcademicPage />}
              />
              <Route
                path="/dam-training-registration"
                element={<DamTrainingRegistrationPage />}
              />
              <Route path="/product-agnostic" element={<ProductAgnosticPage />} />
              <Route path="/immersive-experience" element={<ImmrsExpPage />} />
              <Route path="/our-practice" element={<PracticePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/terms-of-use" element={<TermsPage />} />
              <Route path="/dam-journey" element={<DamJourneyPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="/discovery-framework" element={<DiscoveryPage />} />
              <Route path="/csp-001-case" element={<CaseStudy />} />
              <Route
                path="/case-study-dam-repository"
                element={<CaseStudyDamRepository />}
              />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/congrats" element={<CongratsPage />} />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </React.StrictMode>
  </HelmetProvider>,
);
